
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { session } from '../../../environments/environment.session';
import { ClerkNocService } from '../service/clerk-noc.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
@Component({
  selector: 'app-noc-dashboard',
  templateUrl: './noc-dashboard.component.html',
  styleUrls: ['./noc-dashboard.component.css']
})
export class NocDashboardComponent {
  dataSource: any
  ebillUser: any
  b_acct_id: any;

  constructor(public clerknocservice: ClerkNocService) {

  }
  displayedColumns: any = ['si_no', 'applicant_name', 'file_number', 'letter_number', 'date', 'trans_id', 'amount', 'status'];
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  tabledata: boolean = false
  @ViewChild('paginator0', { static: false }) paginator0!: MatPaginator;
  @ViewChild('sort0', { static: false }) sort0!: MatSort;
  // @ViewChild(MatPaginator, { static: false })
  // set paginator(value: MatPaginator) {
  //   if (this.dataSource) {
  //     this.dataSource.paginator = value;
  //   }
  // }
  // @ViewChild(MatSort, { static: false })
  // set sort(value: MatSort) {
  //   if (this.dataSource) {
  //     this.dataSource.sort = value;
  //   }
  // }

  async ngOnInit() {
    this.ebillUser = JSON.parse(atob(session.erpUser));
    this.b_acct_id = this.ebillUser.b_acct_id
    await this.showcarddata();
  }
  ShowIncObj: any = {}
  todaysBills: any = []
  monthlyBills: any = []
  totalIncome: any = []
  yearlyIncome: any = []
  weeklyBills: any = []
  yearlybills: any = []
  totalIncomeBill: any = []
  yearlyBills: any = []
  async showcarddata() {
    let obj: any = {}
    obj["b_acct_id"] = this.b_acct_id
    let resp = await this.clerknocservice.getdashboarddata(JSON.stringify(obj))
    console.log(resp);
    let dt = new Date()
    let current_dt = dt.getDate()
    let year = dt.getFullYear()
    let month: any = dt.getMonth() + 1
    console.log(dt, " dateeee");
    console.log(current_dt, "todays dateeee");
    console.log(year, "year dateeee");
    console.log(month, "todays month");
    if (month < 10) {
      month = `0${month}`
    } else {
      month = month
    }
    let total_curr_amt = 0
    if (resp["error"] == false) {
      let k = 0
      for (let i = 0; i < resp.data.length; i++) {
        resp.data[i]['new_index'] = k + 1
      }
      this.totalIncomeBill = []
      this.totalIncomeBill = resp.data
      const currentDate = new Date();
      const validBills = resp.data.filter((bill: any) => new Date(bill.bill_date) <= currentDate);
      const validBillstodays = resp.data.filter((bill: any) => {
        const billDate = new Date(bill.bill_date).toDateString();
        const currentDateStr = new Date().toDateString(); // Convert current date to the same format
        return billDate == currentDateStr;
      });
      const monthlyIncome = await this.sumBillsByPeriod(validBills, 'monthly');
      const yearlyIncome = await this.sumBillsByPeriod(validBills, 'yearly');
      // Sum the bill_amount of the remaining bills
      const todaysIncome = validBillstodays.reduce((sum: any, bill: any) => sum + bill.bill_amount, 0);

      console.log("Total Bill Amount until current date:", todaysIncome);
      const oneWeekAgo = new Date();
      oneWeekAgo.setDate(currentDate.getDate() - 7);

      // Filter out bills with bill_date within the last week
      const oneweeek = resp.data.filter((bill: any) => {
        const billDate = new Date(bill.bill_date);
        return billDate >= oneWeekAgo && billDate <= currentDate;
      });

      // Sum the bill_amount of the remaining bills
      const weeklyIncome = oneweeek.reduce((sum: any, bill: any) => sum + bill.bill_amount, 0);

      console.log("Total Bill Amount for the past week:", weeklyIncome);

      console.log("Monthly Income:", monthlyIncome);
      console.log("Yearly Income:", yearlyIncome);
      console.log("Weekly Income:", weeklyIncome);

      console.log(total_curr_amt);
      console.log(yearlyIncome[`${year}`]);

      this.ShowIncObj['monthlyIncome'] = monthlyIncome[`${year}-${month}`]
      this.ShowIncObj['yearlyIncome'] = yearlyIncome[`${year}`]
      this.ShowIncObj['weeklyIncome'] = weeklyIncome

      this.ShowIncObj['todaysIncome'] = todaysIncome
      this.ShowIncObj['totalIncome'] = resp.data.reduce((curr: any, acc: any) => {
        return acc.bill_amount + curr
      }, 0)
      console.log(this.ShowIncObj);

      // Today's bills
      const todayStart = new Date(currentDate);
      todayStart.setHours(0, 0, 0, 0);
      const todayEnd = new Date(currentDate);
      todayEnd.setHours(23, 59, 59, 999);
      this.todaysBills = []
      this.todaysBills = await this.filterBillsByDateRange(resp.data, todayStart, todayEnd, 'todaysbill');
      console.log(this.todaysBills, "todays aray data");
      let j = 0
      for (let i = 0; i < this.todaysBills.length; i++) {
        this.todaysBills[i]["new_index"] = j + 1;

      }
      console.log(this.todaysBills, "todays aray data");



      // this.dataSource = new MatTableDataSource(this.todaysBills)
      // this.dataSource.paginator = this.paginator;
      // this.dataSource.sort = this.sort0;

      this.weeklyBills = []

      this.weeklyBills = await this.filterBillsByDateRange(resp.data, oneWeekAgo, currentDate, 'weeklybills');
      // console.log(this.weeklyBills, "weekly datta")

      let wk = 0
      for (let i = 0; i < this.weeklyBills.length; i++) {
        this.weeklyBills[i]["new_index"] = wk + i;

      }

      console.log(this.todaysBills, "todays aray data");
      this.monthlyBills = []
      // Current month's bills
      const monthStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const monthEnd = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0, 23, 59, 59, 999);
      this.monthlyBills = await this.filterBillsByDateRange(resp.data, monthStart, monthEnd, 'monthlybill');
      let l = 0
      for (let i = 0; i < this.monthlyBills.length; i++) {
        this.monthlyBills[i]["new_index"] = l + i;

      }
      console.log(this.todaysBills, "todays aray data");

      // console.log(this.monthlyBills, "monthlyBills datta")
      this.yearlyBills = []
      // Current year's bills
      const yearStart = new Date(currentDate.getFullYear(), 0, 1);
      const yearEnd = new Date(currentDate.getFullYear(), 11, 31, 23, 59, 59, 999);
      this.yearlyBills = await this.filterBillsByDateRange(resp.data, yearStart, yearEnd, 'yearlybill');

      let m = 0
      for (let i = 0; i < this.yearlyBills.length; i++) {
        this.yearlyBills[i]["new_index"] = m + i;

      }
      console.log(this.yearlyBills, "yearlyBills aray data");

      // console.log(this.yearlyBills, "monthlyBills datta")
    }
  }

  // Function to sum bills by a given period (monthly, yearly, weekly)
  sumBillsByPeriod = (bills: any, period: any) => {
    const groupedBills: any = {};

    bills.forEach((bill: any) => {
      const billDate: any = new Date(bill.bill_date);
      let key: any;

      switch (period) {
        case 'monthly':
          key = `${billDate.getFullYear()}-${String(billDate.getMonth() + 1).padStart(2, '0')}`;
          break;
        case 'yearly':
          key = `${billDate.getFullYear()}`;
          break;

      }

      if (!groupedBills[key]) {
        groupedBills[key] = 0;
      }
      groupedBills[key] += bill.bill_amount;
    });

    return groupedBills;

  };
  changeData(data: any) {
    this.tabledata = true
    this.dataSource = []
    if (data == 'todaysIncome') {
      // this.dataSource=[]
      this.dataSource = new MatTableDataSource(this.todaysBills)
      this.dataSource.paginator = this.paginator0;
      this.dataSource.sort = this.sort0;

    } else if (data == 'monthlyIncome') {

      this.dataSource = new MatTableDataSource(this.monthlyBills)
      this.dataSource.paginator = this.paginator0;
      this.dataSource.sort = this.sort0;
    }
    else if (data == 'weeklyincome') {
      this.dataSource = new MatTableDataSource(this.weeklyBills)
      this.dataSource.paginator = this.paginator0;
      this.dataSource.sort = this.sort0;
    }
    else if (data == 'yearlyIncome') {
      this.dataSource = new MatTableDataSource(this.yearlyBills)
      this.dataSource.paginator = this.paginator0;
      this.dataSource.sort = this.sort0;
    }
    else if (data == 'totalIncome') {
      this.dataSource = new MatTableDataSource(this.totalIncomeBill)
      this.dataSource.paginator = this.paginator0;
      this.dataSource.sort = this.sort0;
    }

  }

  // Function to filter bills by date range
  filterBillsByDateRange = async (bills: any, startDate: any, endDate: any, status: any) => {
    if (status == 'todays') {

      return bills.filter((bill: any) => {
        const billDate = new Date(bill.bill_date);
        return billDate == startDate && billDate <= endDate;
      });
    }
    else {
      return bills.filter((bill: any) => {
        const billDate = new Date(bill.bill_date);
        return billDate >= startDate && billDate <= endDate;
      });
    }
  };


  export() {
    const dataToExport = this.dataSource.data.map((row: any) => ({
      'S.NO.': row.new_index,
      'Applicant Name': row.party_name,
      'File Number': row.file_id,
      'Letter Number': row.lda_letter_number,
      'Date': moment(row.bill_date).format('DD/MM/YYYY'),
      'Transaction ID': row.txn_id,
      'Amount': row.bill_amount,
      'Status': row.status
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, 'Transaction_Data');
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
